export default __webpack_public_path__ + "static/media/icon-twitter.a2c98c2e.svg";